import { computed } from 'vue';

import { auth } from '@/router/auth.routes.enum';
import { dashboard } from '@/router/dashboard.routes.enum';
import { landing } from '@/router/landing.routes.enum';
import { lms } from '@/router/lms.routes.enum';
import { useAuthStore } from '@/stores/auth.store';
import { usePermissionsStore } from '@/stores/permissoins.store';

/*
 * This composable is used to determine which page to consider as the main page
 *  example: if user is logged in, show the lms page or dashboard page, else  check the landing page is enabled or not and show the landing page or lms page or login page based on the permission
 *  how to use: const homePage  = useMainPageRoute();
 * homePage() will return the name of the page to show and the title
 */
export const useMainPageRoute = computed(() => {
  const authStore = useAuthStore();
  // if user is logged in, return dashboard page, we can check if user is logged in or not by authStore.user.id
  const { checkAuthentication } = usePermissionsStore();
  if (authStore?.user) {
    if (import.meta.env.VITE_ALLOW_LANDING === 'false') {
      if (checkAuthentication(lms.root.meta)) {
        return {
          name: lms.root.name,
        };
      } else
        return {
          name: dashboard.root.name,
        };
    } else
      return {
        name: landing.root.name,
      };
  } else {
    // if user is not logged in, check if landing page is enabled or not
    // if landing page is enabled, show landing page
    // if landing page is not enabled, show login page or lms page based on the permission
    if (import.meta.env.VITE_ALLOW_LANDING === 'false') {
      if (checkAuthentication(lms.root.meta)) {
        return {
          name: lms.root.name,
        };
      } else
        return {
          name: auth.login.name,
        };
    } else
      return {
        name: landing.root.name,
      };
  }
});
